module.exports = __webpack_public_path__ + "static/media/transmutr_logo_medium_text_filled.36f06083.svg";